export enum TokenKeysEnum {
  /** Key usado para acceder al token de la sesion */
  ACCESS_TOKEN = 'access_token',

  /** Key usado para acceder al token para refrescar la sesion */
  REFRESH_TOKEN = 'refresh_token',

  /** Key usado para acceder al token para refrescar la sesion */
  REFRESH_TOKEN_SERVICE = 'refresh_token_service',

  /** Key usado para acceder a los datos del usuario */
  USER = 'user',

  /** Key usado para guardar el tiempo de expiracion de la sesion */
  SESSION_EXPIRES = 'session_expires',

  /** Key usado para acceder a los datos del empleado */
  EMPLOYEE = 'employee'
}
